import React, { useEffect, useRef, useState } from "react";

function pad(n){ return String(Math.floor(n)).padStart(2,"0"); }
function fmt(s){ if(s<0||s==null) return "00:00:00"; return `${pad(s/3600)}:${pad((s%3600)/60)}:${pad(s%60)}`; }

/** Active build timer — excludes pause intervals; ticks only when status===LIVE. */
export function ActiveBuildTimer({ startTime, finishTime, status, pauseIntervals=[], currentPauseStartedAt, size="lg" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { if (status !== "LIVE") return; const id = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(id); }, [status]);
  if (!startTime) return <TimerText s={0} size={size} />;
  const start = new Date(startTime).getTime();
  const cutoff = finishTime ? new Date(finishTime).getTime() : (status === "PAUSED" && currentPauseStartedAt ? new Date(currentPauseStartedAt).getTime() : now);
  let paused = 0;
  for (const iv of pauseIntervals) {
    if (iv.start && iv.end) paused += (new Date(iv.end) - new Date(iv.start));
  }
  if (status === "PAUSED" && currentPauseStartedAt) {
    // stopped at pause start; nothing extra to add
  }
  const active = Math.max(0, Math.floor((cutoff - start - paused) / 1000));
  return <TimerText s={active} size={size} />;
}

export function PausedTimer({ pauseIntervals=[], currentPauseStartedAt, status, size="md" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { if (status !== "PAUSED") return; const id = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(id); }, [status]);
  let paused = 0;
  for (const iv of pauseIntervals) if (iv.start && iv.end) paused += (new Date(iv.end) - new Date(iv.start));
  if (status === "PAUSED" && currentPauseStartedAt) paused += (now - new Date(currentPauseStartedAt).getTime());
  return <TimerText s={Math.max(0, Math.floor(paused/1000))} size={size} />;
}

function TimerText({ s, size }) {
  const cls = size === "xl" ? "text-6xl md:text-7xl" : size === "lg" ? "text-4xl md:text-5xl" : "text-lg";
  return <span className={`${cls} font-medium text-white`} style={{ fontVariantNumeric: "tabular-nums" }} data-testid="build-timer">{fmt(s)}</span>;
}
